import { render, staticRenderFns } from "./BaseModalDuplicatePeriod.vue?vue&type=template&id=0ba1004e&"
import script from "./BaseModalDuplicatePeriod.vue?vue&type=script&lang=js&"
export * from "./BaseModalDuplicatePeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports